<div class="container-fluid p-0 white">
<app-header [title]="Title"></app-header>

<div class="col-md-12 col-sm-12 col-sm-12 p-0">
  <div class="col-md-12 col-sm-12 p-0 super-deallocation">

  <form [formGroup]="ticketForm" class="form-horizontal" role="form" (ngSubmit)="onSubmit()"
  style="padding: 20px">

    <div class="row p-0 mt-10" style="margin-left: 54px !important;">

        <div class="col-sm-3 col-md-3 p-0">
          <div class="form-group mb-0">
              <div style="width: 80%;">
                <label class=" label-std control-label p-0 b-600 pl-0" for="">Client</label>
                <app-common-dropdown-search #dropdown *ngIf="clientList.length > 0" [width]="100" [data]="clientList" [addFieldSetting]="addFieldSetting"
                  (callEvent)="onClientChange($event)"></app-common-dropdown-search>
              </div>
          </div>
        </div>

        <div class="col-sm-3 col-md-3 p-0">
          <label class="label-std control-label p-0 b-600 pl-0" for="Priority">Priority
            <span class="required-asterisk">*</span>
          </label>
          <select class="form-control" formControlName="Priority" id="Priority"
          [style.border-color]="ticketForm.get('Priority').hasError('required') && validated ? 'red !important' : ''">
            <option value="" disabled selected>Select Priority</option>
            <option [value]="item.id" *ngFor="let item of priorityList">{{item.name}}</option>
            <!-- Add more options as needed -->
          </select>
        </div>

      <div class="col-sm-3 col-md-3 p-0">
        <label class="label-std control-label p-0 b-600 pl-0" for="Severity">Severity
          <span class="required-asterisk">*</span>
        </label>
        <select class="form-control" formControlName="Severity" id="Severity"
        [style.border-color]="ticketForm.get('Severity').hasError('required') && validated ? 'red !important' : ''">
          <option value="" disabled selected>Select Severity</option>
          <option [value]="item.name" *ngFor="let item of severityList">{{item.name}}</option>
          <!-- Add more options as needed -->
        </select>
      </div>

    <div class="col-sm-3 col-md-3 p-0">
      <label class="label-std control-label p-0 b-600 pl-0" for="Description">Email <span
          class="required-asterisk">*</span></label>
      <input type="email" class="form-control" id="lastname" placeholder=""
        formControlName="CreatedBy" maxlength="50" disabled style="width: 60%;">
    </div>

    </div>

    <div class="row p-1 mt-10" style="margin-left: 54px !important;">
      <div class="col-sm-3 col-md-3 p-0">
        <label class="label-std control-label p-0 b-600 pl-0" for="Title">Title
          <span class="required-asterisk">*</span>
        </label>
        <input class="form-control" formControlName="Title" id="Title" type="text"
        [style.border-color]="ticketForm.get('Title').hasError('required') && validated ? 'red !important' : ''"
        (keyup)="commonService.checkIsSpecialCharacter($event,'Title',ticketForm)">
      </div>

      <div class="col-sm-3 col-md-3 p-0">
        <label class="label-std control-label p-0 b-600 pl-0" for="Uploadedfile">Attachment</label>
        <input #fileInputControl multiple class="form-control filesInput" type="file" formControlName="Uploadedfile" id="Uploadedfile"
        [style.border-color]="ticketForm.get('Uploadedfile').hasError('required') && validated ? 'red !important' : ''"
        style="padding: 3px"
        (change)="changeListener($event)">

        <span class="file-cancel cursor" (click)="removeFile()" title="Clear all">
          <i class="fa fa-times pe-all" aria-hidden="true" style="font-size: inherit;"></i>
        </span>

        <label for="Uploadedfile" style="margin-top: 40px;width: 80%;">
          <span class="file-button">
            <i class="fa fa-upload" aria-hidden="true"></i>
            Select File
          </span>

        <div for="Uploadedfile"
        cdkDropList
        #fileDropList="cdkDropList"
        [cdkDropListData]="uploadedFiles"
        (cdkDropListDropped)="drop($event)"
        class="drop-list"
        cdkDrop
      >
        <div class="drop-zone" *ngIf="!ticketForm.get('Uploadedfile').value.length">
          <p>Drag and drop files here or click Select to browse</p>
        </div>
        <ng-container *ngFor="let file of uploadedFiles; let i = index">

        <div class="d-flex">
          <div class="file col-md-12 col-sm-12">
            {{ file.name }}
          </div>
          <!-- <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor pe-none" (click)="removeFile(file)">
            <i class="fa fa-times pe-all" aria-hidden="true" style="font-size: inherit;"></i>
          </span> -->
       </div>
      </ng-container>
      </div>
      </label>
      </div>

      <div class="col-sm-6 col-md-6 p-0">
        <label class="label-std control-label p-0 b-600 pl-0" for="Description">Description <span
            class="required-asterisk">*</span></label>
        <textarea class="form-control" formControlName="Description" id="Description"
        [style.border-color]="ticketForm.get('Description').hasError('required') && validated ? 'red !important' : ''" style="max-height: 100px;"
        (keyup)="commonService.checkIsSpecialCharacter($event,'Description',ticketForm)"></textarea>
      </div>

    </div>

      <div class="p-0 buttons">
        <button class="btn blue square-btn blue-hover btn-txt btn-default" type="submit"
        [disabled]="ticketForm.invalid || ClientId == null">Submit</button>
        <button class="btn blue square-btn blue-hover btn-txt btn-default" type="button"
          (click)="onClear()">Clear</button>
      </div>

      <hr style="margin: 2px;">

      <div class="row p-0" style="width: 100%;">
        <div class="col-md-12 p-0" style="margin-top: -25px;">
          <div class="col-md-12 col-sm-12 p-0 insrt-tbl">
            <div style="text-align: center;margin-top: 30px;" *ngIf="isLoaded">
              <i class="fa fa-refresh fa-spin fa-5x"></i>
              <p>Getting Information</p>
            </div>
            <div *ngIf="errorMessage" style="text-align: center;margin-top: 30px;">
              <h3><b>No Data Found</b></h3>
            </div>
            <div *ngIf="rowData && rowData.length > 0" class="sticky-table sticky-ltr-cells popup-table-height">
              <ag-grid-angular class="ag-theme-balham gd-w grid-w" (gridReady)="onGridReady($event)"
                [rowSelection]="RowSelection" [rowData]="rowData" [columnDefs]="columnDefs" [enableColResize]="true"
                [enableSorting]="true" [enableFilter]="true" [suppressRowClickSelection]="true"
                [pagination]="true" [paginationPageSize]="15"
                (cellClicked)='onCellClicked($event)'>
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>

      <div class="loaderDownloaded" *ngIf="isDownloaded || isSubmited">
        <i class="fa fa-refresh fa-spin fa-5x"></i>
      </div>

    </form>
  </div>
</div>


